export enum FilterCriteriaFields {
  JOB_TITLE = 'job_title',
  JOB_ACTIVITY_AREA = 'job_activity_area',
  JOB_CONTRACT_TYPE = 'job_contract_type',
  JOB_HOURLY_TYPE = 'job_hourly_type',
  JOB_SEARCH_AREA_RANGE = 'job_search_area_range',
  JOB_QUALIFICATION = 'job_qualification',
  JOB_START_DATE = 'job_start_date',
  JOB_END_DATE = 'job_end_date',
  JOB_PUBLICATION_START_DATE = 'job_publication_start_date',
  JOB_PUBLICATION_END_DATE = 'job_publication_end_date',
  JOB_REFERENCE_NUMBER = 'job_reference_number',
  JOB_STATUS = 'job_status',
  JOB_IDS = 'job_ids',
  JOB_CITY_ID = 'job_city_id',
  JOB_CITY_NAME = 'job_city_name',

  ESTABLISHMENT_ACTIVITY_AREA = 'establishment_activity_area',
  ESTABLISHMENT_SEARCH_AREA_RANGE = 'establishment_search_area_range',
  ESTABLISHMENT_IDS = 'establishment_ids',
  ESTABLISHMENT_ID = 'establishment_id',
  ESTABLISHMENT_SIRET = 'establishment_siret',
  ESTABLISHMENT_STATUS = 'establishment_status',
  ESTABLISHMENT_CITY_ID = 'establishment_city_id',

  APPLICATION_CREATED_AT_FROM = 'application_created_at_from',
  APPLICATION_CREATED_AT_TO = 'application_created_at_to',

  CV_VIDEO_QUALIFICATION = 'cv_video_qualification',

  CANDIDATE_ACTIVITY_AREA = 'candidate_activity_area',
  CANDIDATE_QUALIFICATION = 'candidate_qualification',
  CANDIDATE_SEARCH_AREA_RANGE = 'candidate_search_area_range',
  CANDIDATE_TAGS = 'candidate_tags',
  CANDIDATE_YEARS_EXPERIENCE = 'candidate_years_experience',
  CANDIDATE_STATUS = 'candidate_status',

  ENTERPRISE_STATUS = 'enterprise_status',
  ENTERPRISE_NAME = 'enterprise_name',
  ENTERPRISE_SIREN = 'enterprise_siren',
  ENTERPRISE_CITY_ID = 'enterprise_city_id',
  ENTERPRISE_ID = 'enterprise_id',

  USER_FULLNAME = 'user_fullname',
  USER_EMAIL = 'user_email',
  USER_MOBILEPHONE = 'user_mobilephone',
  USER_STATUS = 'user_status',
  USER_ROLE = 'user_role',
  USER_CITY_ID = 'user_city_id',
  USER_CITY_NAME = 'user_city_name',

  CVVIDEO_STATUS = 'cv_video_status',

  CREDIT_ENTERPRISE = 'credit_topup_enterprise',
  CREDIT_TOPUP_AMOUNT_MIN = 'credit_topup_amount_min',
  CREDIT_TOPUP_CREDIT_MIN = 'credit_topup_credit_min',
  CREDIT_TOPUP_AMOUNT_MAX = 'credit_topup_amount_max',
  CREDIT_TOPUP_CREDIT_MAX = 'credit_topup_credit_max',
  CREDIT_TOPUP_CREATED_AT_FROM = 'credit_topup_created_at_from',
  CREDIT_TOPUP_CREATED_AT_TO = 'credit_topup_created_at_to',

  CREDIT_CONSUMPTION_ENTERPRISE_ID = 'credit_consumption_enterprise_id',
  CREDIT_CONSUMPTION_ESTABLISHMENT_ID = 'credit_consumption_establishment_id',
  CREDIT_CONSUMPTION_CREATED_AT_FROM = 'credit_consumption_created_at_from',
  CREDIT_CONSUMPTION_CREATED_AT_TO = 'credit_consumption_created_at_to',
  CREDIT_CONSUMPTION_CREATED_BY = 'credit_consumption_created_by',
  CREDIT_CONSUMPTION_ACTION = 'credit_consumption_action',
}
